import type {PrimitiveType, PropertyMap} from "../../common/utils/objects";

export class FormPathAggregator {

    public path: string[];

    public constructor(id: string) {
        this.path = [id];
    }

    public addScope(scopeId: string): void {
        this.path.unshift(scopeId);
    }
}

export type InputType = PrimitiveType | PropertyMap;